'use client';

import React, { CSSProperties, useRef, useState } from 'react';
import { Skeleton } from '@tuic/web-compositions/core/Skeleton';
import { ComponentBlock } from '@modules/prism-client/types/types';
import { Mxp365Iframe } from '../../mxp365/Mxp365Iframe';
import { HeaderSection, type HeaderSectionProps } from '@tuic/web-compositions/shared/HeaderSection';
import { twMerge } from '../../../../../../../../packages/tailwind-config';
import { useToasts } from '@tuic/web-compositions/shared/Toaster';
import { MxpIframeHeightChangeHandler, MxpIframeRef } from '@modules/mxp-dialog';
import { useMxpActionFavoriteAdded, useMxpActionShare } from '@modules/mxp-dialog/hooks';
import { useScreenNameAtLeast } from '@tuic/web-compositions/hooks/use-screen-name-at-least';
type IframeProps = React.ComponentProps<typeof Mxp365Iframe>;
export type Mxp365IframeBlockData = IframeProps & {
  header?: HeaderSectionProps;
};
export const Mxp365IframeBlock: ComponentBlock<Mxp365IframeBlockData> = ({
  data: rawData,
  fallback
}) => {
  const {
    header,
    ...data
  } = rawData || {} as Mxp365IframeBlockData;
  let [height, setHeight] = useState<number>();
  let atLeastMd = useScreenNameAtLeast('md');
  const {
    push
  } = useToasts();
  const iframeRef = useRef<MxpIframeRef | null>(null);
  const handleShare = useMxpActionShare();
  const handleFavoriteAdded = useMxpActionFavoriteAdded(push, iframeRef);
  let handleHeightChange: MxpIframeHeightChangeHandler = ({
    height
  }) => {
    setHeight(height);
  };
  if (fallback) {
    return <Skeleton className="w-full h-[70vh]" />;
  }
  if (!data) return null;
  return <div className="space-y-6" data-sentry-component="Mxp365IframeBlock" data-sentry-source-file="Mxp365IframeBlock.tsx">
      {!!header && <HeaderSection {...header} fallback={fallback} />}
      <Mxp365Iframe width={'100%'} ref={iframeRef} onMxpFavoriteAdded={handleFavoriteAdded} onMxpShare={handleShare} onMxpHeightChange={handleHeightChange} {...data} className={twMerge('w-full h-[70vh] md:max-h-[70vh]', data.className)} style={{
      height: getCssHeight(height, atLeastMd)
    }} data-sentry-element="Mxp365Iframe" data-sentry-source-file="Mxp365IframeBlock.tsx" />
    </div>;
};
const getCssHeight = (height: number | undefined, atLeastMd: boolean): string => {
  if (typeof height !== 'undefined') {
    return `${height + 2}px`;
  }
  if (atLeastMd) {
    return '70vh';
  }
  return '1000px';
};